<template>
  <v-style>
    body, .body-confirmation-layout { background-color: white; }
  </v-style>
  <main class="body-confirmation-layout text-center d-flex flex-column h-100">
    <slot />
    <DefaultFooter />
  </main>
</template>

<script>
import { onMounted } from "@vue/runtime-core";
import DefaultFooter from "@/components/DefaultFooter.vue";

export default {
  components: { DefaultFooter },
  setup: () => {
    onMounted(() => {
      console.debug("Component is mounted!");
    });
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>
<style>
.body-confirmation-layout {
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  /* background-color: #f5f5f5; */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  height: 100%;
}
</style>
